import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import {
  JackingFormInstanceEditor,
  JackingFinalValuesTemplateEditor,
  JackingFormLegLayoutTemplateEditor,
} from '../../../../../../models/jacking-v2/jacking.models';

@Component({
  selector: 'jacking-final-values',
  templateUrl: 'jacking-final-values.component.html'
})
export class JackingFinalValuesComponent implements OnInit, OnChanges {
  @Input() editor: JackingFormInstanceEditor;
  @Input() group: any;
  @Input() legsCount: number;
  @Input() isReadonly: boolean = false;
  @Input() activitySpansMultipleDays: boolean = false;

  constructor(private elementRef: ElementRef) {}

  ngOnInit() {
    this.safeInit();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['editor']) {
      this.safeInit();
    }
  }

  private safeInit() {
    if (!this.editor) {
      return;
    }

    // Ensure root exists for all child components
    (this.editor as any).jackingFinalValues = (this.editor as any).jackingFinalValues || {};
  }

  get finalValuesTemplate(): JackingFinalValuesTemplateEditor {
    return (this.editor as any)?.template?.finalValuesTemplate || null;
  }

  get hasAnyFinalValuesSection(): boolean {
    const t = this.finalValuesTemplate;
    if (!t) { return false; }

    return !!(
      t.hasFinalLegValues ||
      t.hasFinalPenetrations ||
      t.hasDifferenceFromExpected ||
      t.hasRpd ||
      t.hasFinalAirGap ||
      t.hasLiftPumpsUsed ||
      t.hasDepthDeployed ||
      t.hasNorthingEasting
    );
  }

  get orderedLegNumbers(): number[] {
    const layouts: JackingFormLegLayoutTemplateEditor[] = (this.editor as any)?.template?.legLayouts || [];
    if (layouts.length) {
      return layouts
        .slice()
        .sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0))
        .map(l => l.legNumber);
    }

    const count = this.legsCount || 0;
    return Array.from({ length: count }, (_, i) => i + 1);
  }

  onNotesKeyDown(event: KeyboardEvent) {
    if (event.key !== 'Tab' || event.shiftKey) {
      return;
    }

    const firstPositionInput = this.elementRef.nativeElement
      .querySelector('.position-wrap input:not([disabled])') as HTMLInputElement | null;

    if (!firstPositionInput) {
      return;
    }

    event.preventDefault();
    firstPositionInput.focus();
  }
}



// WEBPACK FOOTER //
// ./src/pages/jacking-activities/v2/components/jacking-events/jacking-final-values/jacking-final-values.component.ts